import { Folder, FolderDispInfo } from "../../../domain/folder";
import { DateTimeConverter } from "../../utilities";
import { IFolderBean, IFolderDisplayBean } from "../beans";

export class FolderTranslator {
  static toFolderDispInfo(bean: IFolderDisplayBean): FolderDispInfo {
    if (!bean) { throw new Error("bean is empty!!!"); }
    const result = new  FolderDispInfo();
    result.forceCompressionCount = bean.forceCompressionCount;
    
    return result;
  }

  static toFolder(bean: IFolderBean): Folder {
    if (!bean) { throw new Error("bean is empty!!!"); }

    const result = new Folder();
    result.comment = bean.comment;
    result.url = bean.url;
    result.guid = bean.guid;
    result.size = bean.size;
    result.maxSize = bean.maxSize;
    result.createDateTime = DateTimeConverter.toDate(bean.createDateTime);
    result.expirationDateTime = DateTimeConverter.toDate(bean.expirationDateTime);
    result.password = bean.password;
    result.published = bean.published;
    return result;
  }

  static toFolderBean(source: Folder): IFolderBean {
    if (!source) { throw new Error("source is empty!!!"); }

    return {
      comment: source.comment,
      url: source.url,
      guid: source.guid,
      size: source.size,
      maxSize: source.maxSize,
      createDateTime: null,
      expirationDateTime: null,
      password: source.password,
      published: source.published,
    };
  }
}
